import 'focus-visible';
import Drupal from './core/Drupal';
import Sticky from './core/Sticky';
import DDTemplates from './core/DDTemplates';
import CalendarFeed from './views/CalendarFeed';
import Navigation from './components/Navigation';
import TermNavigation from './core/TermNavigation';
import FixNavigation from './modifiers/FixNavigation';
import FetchSourceImages from './core/FetchSourceImages';
import Shift from './modifiers/Shift';
import Header from './Header';
import Toolbar from './Toolbar';
import HomeHero from './HomeHero';
import HomeMembers from './HomeMembers';
import HomeQuicklinks from './HomeQuicklinks';
import HomeWebinars from './HomeWebinars';

// Homepage funcationality
const homepage = () => {
  // Home Hero Block
  const heroBlock = document.querySelector('.home-hero.block');
  if (heroBlock && !heroBlock.HomeHero) {
    heroBlock.HomeHero = new HomeHero(heroBlock);
  }

  // Home Members Block
  const membersBlock = document.querySelector('.home-members.block');
  if (membersBlock && !membersBlock.HomeMembers) {
    membersBlock.HomeMembers = new HomeMembers(membersBlock);
  }

  // Home Quicklinks Block
  const quicklinksBlock = document.querySelector('.home-quicklinks.block');
  if (quicklinksBlock && !quicklinksBlock.HomeMembers) {
    quicklinksBlock.HomeMembers = new HomeQuicklinks(quicklinksBlock);
  }

  // Home Webinars Block
  const webinarsBlock = document.querySelector('.home-webinars.block');
  if (webinarsBlock && !webinarsBlock.HomeWebinars) {
    webinarsBlock.HomeWebinars = new HomeWebinars(webinarsBlock);
  }

  // Add homepage ready state
  document.body.classList.add('homepage-ready');
};

// Sitewide functionality
const sitewide = () => {
  // Page element
  const page = document.querySelector('.page');

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Shift Components based on currrent breakpoint.
  const pageHeader = document.querySelector('.page-header');
  if (!pageHeader.Shift) {
    pageHeader.Shift = new Shift(pageHeader);
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Main Navigation
  const mainMenu = document.querySelector('#nice-menu-3');
  if (mainMenu && !mainMenu.Navigation) {
    mainMenu.Navigation = new Navigation(mainMenu);
  }

  // Controls the states of the menu and search states
  const toolbar = document.querySelector('.toolbar');
  if (toolbar && !toolbar.Toolbar) {
    toolbar.Toolbar = new Toolbar(toolbar);
  }

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Term Navigation
  const termNavigation = document.querySelector('.term-navigation');
  if (termNavigation && !termNavigation.TermNavigation) {
    termNavigation.TermNavigation = new TermNavigation(termNavigation);
  }

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });
};

// Add sitewide functionality
Drupal.behavior(sitewide);

// Add homepage specific functionality
if (document.body.classList.contains('front')) {
  Drupal.behavior(homepage);
}

// If we're in development mode...
// Open up all missing images within a new tab/window.
if (process.env.NODE_ENV === 'development') {
  document.body.FetchSourceImages = new FetchSourceImages();
}
